module.exports = __webpack_public_path__ + "static/img/bg53.e55b04f3.png";